function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.65,
  d: "M21.7151 5.82858C22.9723 5.48572 23.7723 4.11429 23.4294 2.85715C23.0866 1.6 21.7151 0.800004 20.458 1.14286C19.2008 1.48572 18.4008 2.85715 18.7437 4.11429C19.0865 5.37143 20.458 6.17143 21.7151 5.82858Z",
  fill: "#1B6EE4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.65,
  d: "M3.42855 5.82858C4.68569 5.48572 5.48569 4.11429 5.14283 2.85715C4.91426 1.6 3.54283 0.800004 2.28569 1.14286C0.914261 1.48572 0.114261 2.85715 0.457119 4.11429C0.799976 5.37143 2.1714 6.17143 3.42855 5.82858Z",
  fill: "#6EA3EE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.42899 22.9714C4.68613 22.6285 5.48613 21.2571 5.14327 20C4.80042 18.7428 3.42899 17.9428 2.17184 18.2857C0.914702 18.6285 0.114702 20 0.457559 21.2571C0.800416 22.5143 2.17184 23.3143 3.42899 22.9714Z",
  fill: "#D1E2FA"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7151 22.9714C22.9723 22.6285 23.7723 21.2571 23.4294 20C23.0866 18.7428 21.7151 17.9428 20.458 18.2857C19.2008 18.6285 18.4008 20 18.7437 21.2571C19.0865 22.5143 20.458 23.3143 21.7151 22.9714Z",
  fill: "#6EA3EE"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0001 20.2286C7.54291 20.2286 3.77148 16.5715 3.77148 12.0001C3.77148 7.54291 7.42863 3.77148 12.0001 3.77148C16.4572 3.77148 20.2286 7.42863 20.2286 12.0001C20.2286 16.4572 16.4572 20.2286 12.0001 20.2286Z",
  fill: "#1B6EE4"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7429 15.3143C10.5144 15.3143 10.2858 15.2 10.1715 15.0857L8.22866 13.3714C7.88581 13.0285 7.88581 12.4571 8.11438 12.1143C8.45724 11.7714 9.02866 11.7714 9.37152 12L10.7429 13.1428L14.2858 9.3714C14.6287 9.02854 15.2001 9.02854 15.5429 9.3714C15.8858 9.71426 15.8858 10.2857 15.5429 10.6285L11.3144 14.9714C11.2001 15.2 10.9715 15.3143 10.7429 15.3143Z",
  fill: "white"
});

function SvgValidationLogoSimple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationLogoSimple);
export default __webpack_public_path__ + "static/media/validation_logo_simple.3da942a2.svg";
export { ForwardRef as ReactComponent };